// extracted by mini-css-extract-plugin
export var cartIcon = "_ow-0";
export var cartIconContainer = "_ow-1";